import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import AIAnswerBlock from './components/AIAnswerBlock';
import Process from './components/Process';
import WhyUs from './components/WhyUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <AIAnswerBlock />
      <Process />
      <WhyUs />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <ContactCTA />
      <Footer />
    </main>
  );
}
